import React from 'react';
import { Box, Grid, Card, CardContent, Typography } from '@mui/material';

const SummaryCard = ({ stat, statName, Icon }: { stat: number; statName: string; Icon: React.ElementType }) => {
  return (
    <Grid item xs={12} sm={6} md={4}>
      <Card elevation={3} sx={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CardContent>
          <Box display="flex" alignItems="center" justifyContent='center' mb={1}>
            <Icon color="primary" sx={{ fontSize: 40, mr: 1 }} />
            <Typography variant="h5" component="div">
              {stat}
            </Typography>
          </Box>
          <Typography color="text.secondary">
            {statName}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default SummaryCard;